import { SyntheticEvent } from 'react';

// Keep the same default avatar as the Account/Avatar backend endpoint.
export const DEFAULT_AVATAR_URL = 'https://timetask.ru/img/ava/default/ava.jpg';

export function handleAvatarLoadError(event: SyntheticEvent<HTMLImageElement>) {
    const image = event.currentTarget;
    if (image.getAttribute('src') !== DEFAULT_AVATAR_URL) {
        image.src = DEFAULT_AVATAR_URL;
    }
}
